import { BaseSkeleton } from 'components/BaseSkeleton'

import { BAR_WIDTHS } from './bars-chart-skeleton.consts'

import './bars-chart-skeleton.styles.scss'

export const BarsChartSkeleton = () => {
  return (
    <div className="BarsChartSkeleton">
      <div className="BarsChartSkeleton-chart">
        {BAR_WIDTHS.map(width => (
          <BaseSkeleton key={`left-${width}`} borderRadius="12px" height="50px" width={width} />
        ))}
      </div>
      <div className="BarsChartSkeleton-chart">
        {BAR_WIDTHS.map(width => (
          <BaseSkeleton key={`right-${width}`} borderRadius="12px" height="50px" width={width} />
        ))}
      </div>
    </div>
  )
}
